import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class SettingsRoutesResolver implements Resolve<any> {
  resolve (route: ActivatedRouteSnapshot) {
    return route.data.activeRoute;
  }
}
